import { createContext, useContext } from "react";

/**
 * True while this screen is the VISIBLE keep-alive tab. KeepAliveOutlet never unmounts
 * a hidden tab (display:none), so screen-level side effects that are global (e.g. the
 * Query Inspector registration) must check this instead of relying on unmount.
 * Default `true`: screens rendered outside KeepAliveOutlet are always "active".
 */
const KeepAliveActiveContext = createContext<boolean>(true);

export const KeepAliveActiveProvider = KeepAliveActiveContext.Provider;

export const useIsKeepAliveActive = (): boolean => useContext(KeepAliveActiveContext);
